




import Vue from "vue";

export default Vue.extend ({
    name: "Container",

    data: function() {
        return {
            currentStep: 0,

        };
    }
});
